import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconClock9OClock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconClock9OClock"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M12 6V12H7" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconClock9OClock;
